__webpack_require__.p = "/techXChange/";